/* ahm-life-inventory.js — Home: "Shop by real life" (sections/home-life.liquid)
   and the curated inventory (sections/home-curated.liquid). Both sections wrap
   their markup in <div data-slot="life-inventory">, so this one view renders
   whichever part a slot holds.
   1. SHOP BY REAL LIFE: the 8 tiles are server-rendered (title, line, link).
      This script adds the live count, a real photo of a car that matches the
      need (a different car per tile where possible) and the right link:
      matches → stock filtered by need; none → the Find-me-a-car request.
   2. CURATED INVENTORY: a bounded selection (hand-picked in the theme editor,
      else the newest cars with photos), composed in blocks of
      [feature + 1] then [3], alternating the feature side, closed by a
      concierge panel sized to fill whatever the last row leaves.
      Works for 0, 1, 6 or 1,200+ cars. */
(function () {
  'use strict';
  var M = window.M; if (!M) return;
  if (window.__ahmLifeInventory) return; // both sections load this file
  window.__ahmLifeInventory = 1;
  var esc = M.esc;

  function isDesign() { return document.documentElement.classList.contains('is-design-mode'); }
  function nonRoad(c) { return M.NON_ROAD.test(c.body || ''); }
  function hasPhoto(c) { return !!(c.photos && c.photos.length); }
  // "hero-ok" (feed key `hero`): the car's first photo was checked by eye as a clean exterior. Automatic
  // photo picks on the home page use only these, so an unchecked photo (dealer plate, interior) never leads.
  function cleanPhoto(c) { return hasPhoto(c) && c.hero === true; }
  function seenOf(c) { return String(c.seen || ''); }
  // newest listing first, then newest model year, then lowest mileage
  function newest(a, b) {
    var s = seenOf(b).localeCompare(seenOf(a)); if (s) return s;
    var y = (Number(b.year) || 0) - (Number(a.year) || 0); if (y) return y;
    return (a.km == null ? Infinity : a.km) - (b.km == null ? Infinity : b.km);
  }
  function photoScore(p) { if (!p) return -1; var w = p.w || 0, h = p.h || 0; return (w && h && w >= h ? 2 : 0) + (w >= 1000 ? 1 : 0); }

  /* ---------- 1. Shop by real life ------------------------------------- */
  // Best photo for a need: a matching car not already shown on another tile,
  // preferring cars here now, landscape and larger photos, newest first.
  function pickPhoto(list, usedCar, usedPhoto) {
    var ranked = list.filter(cleanPhoto).sort(function (a, b) {
      var sa = (a.status === 'in' ? 4 : 0) + photoScore(M.photoOf(a));
      var sb = (b.status === 'in' ? 4 : 0) + photoScore(M.photoOf(b));
      return (sb - sa) || newest(a, b);
    });
    var i, c;
    for (i = 0; i < ranked.length; i++) {
      c = ranked[i];
      var ci = c.cover || 0;
      if (!usedCar[c.ref] && !usedPhoto[c.ref + '#' + ci]) return { car: c, idx: ci, p: M.photoOf(c) };
    }
    // every matching car is already on a tile: reuse one (only first photos are checked as clean)
    return ranked.length ? { car: ranked[0], idx: ranked[0].cover || 0, p: M.photoOf(ranked[0]) } : null;
  }

  function renderTiles(ul, cars) {
    var usedCar = {}, usedPhoto = {}, total = cars.length;
    ul.querySelectorAll('[data-need]').forEach(function (li) {
      var need = M.need(li.getAttribute('data-need'));
      var a = li.querySelector('.li-tile__link');
      if (!need || !a) return;
      var big = li.classList.contains('li-tile--big');
      var list = cars.filter(need.test);
      var n = list.length, nin = 0;
      list.forEach(function (c) { if (c.status === 'in') nin++; });
      var nway = n - nin;

      // photo: a real car that matches; otherwise keep the merchant's fallback image (if any)
      var pick = pickPhoto(list, usedCar, usedPhoto);
      var media = li.querySelector('.li-tile__media');
      if (pick && pick.p && media) {
        usedCar[pick.car.ref] = 1; usedPhoto[pick.car.ref + '#' + pick.idx] = 1;
        var sizes = big ? '(max-width: 600px) 100vw, 660px' : '(max-width: 600px) 50vw, 340px';
        media.innerHTML = M.img(pick.p, { sizes: sizes, alt: '', cls: 'li-tile__photo' });
      }

      var label = li.querySelector('.li-tile__title');
      var title = label ? label.textContent.trim() : need.label;
      var split = [nin ? M.fmt(nin) + ' here now' : '', nway ? M.fmt(nway) + ' arriving' : ''].filter(Boolean).join(' · ');
      var foot = li.querySelector('.li-tile__foot');
      var aria;
      if (n) {
        a.setAttribute('href', M.stockUrl({ need: need.key }));
        if (foot) foot.innerHTML =
          '<span class="li-tile__count t-num"><b>' + M.fmt(n) + '</b> ' + (n === 1 ? 'car' : 'cars') + ' online' +
            (split ? '<span class="li-tile__split"> · ' + esc(split) + '</span>' : '') + '</span>' +
          '<span class="li-tile__go">See ' + (n === 1 ? 'it' : 'them') + ' <span class="arr" aria-hidden="true">&rarr;</span></span>';
        aria = title + ': ' + M.fmt(n) + (n === 1 ? ' car' : ' cars') + ' online' + (split ? ', ' + split : '');
      } else {
        a.setAttribute('href', M.urls.find + '?need=' + encodeURIComponent(need.key));
        // "None online" only when the stock list actually loaded with cars in it
        if (foot) foot.innerHTML =
          (total ? '<span class="li-tile__count li-tile__count--zero">None online right now</span>' : '') +
          '<span class="li-tile__go">We&rsquo;ll source one <span class="arr" aria-hidden="true">&rarr;</span></span>';
        aria = title + ': ' + (total ? 'none online right now. ' : '') + 'We will source one for you';
      }
      a.setAttribute('aria-label', aria);
      li.classList.toggle('is-zero', !n);
      if (!M.reducedMotion && !a.hasAttribute('data-li-lit')) { a.setAttribute('data-li-lit', ''); M.pointerLight(a); }
    });
  }

  /* ---------- 2. Curated inventory ------------------------------------- */
  var PREMIUM = ['luxury', 'exec'], EVERYDAY = ['economy', 'hailing', 'hybrid'];
  function hasAny(car, keys) { var ns = M.needsOf(car); return keys.some(function (k) { return ns.indexOf(k) > -1; }); }

  // The selection: the merchant's hand-picked cars (in their order), else the
  // newest cars that have photos (photo-less cars only if nothing else exists).
  function select(cars, max, picks) {
    if (picks && picks.length) {
      var byHandle = {};
      cars.forEach(function (c) { var h = M.carHandle(c); if (h) byHandle[h] = c; });
      var chosen = [], seen = {};
      picks.forEach(function (h) { var c = byHandle[h]; if (c && !seen[c.ref]) { seen[c.ref] = 1; chosen.push(c); } });
      if (chosen.length) return { cars: chosen.slice(0, max), picked: true };
    }
    // Only road cars whose first photo is checked clean (hero-ok), newest first, at most two of any one make
    // so the range shows; then more hero-ok road cars fill any gap. Never an unchecked photo: fewer cards
    // (the concierge panel closes the row) is better than a dealer plate or an interior leading the section.
    var road = cars.filter(function (c) { return cleanPhoto(c) && !nonRoad(c) && !/\b(van|box)\b/i.test(c.body || ''); }).sort(newest);
    var more = cars.filter(function (c) { return cleanPhoto(c) && !nonRoad(c) && /\b(van|box)\b/i.test(c.body || ''); }).sort(newest);
    var out = [], perMake = {}, used = {};
    road.forEach(function (c) {
      if (out.length >= max) return;
      var mk = String(c.make || '').toLowerCase();
      if ((perMake[mk] || 0) >= 2) return;
      perMake[mk] = (perMake[mk] || 0) + 1; used[c.ref] = 1; out.push(c);
    });
    road.concat(more).forEach(function (c) { if (out.length < max && !used[c.ref]) { used[c.ref] = 1; out.push(c); } });
    return { cars: out, picked: false };
  }

  // Editorial order for an automatic selection: feature slots (every 5th card)
  // alternate premium / everyday so the range shows; a feature needs a good
  // landscape photo and a road car. Supporting slots rotate other / everyday / premium.
  function editorialOrder(cars) {
    var P = [], E = [], O = [];
    cars.forEach(function (c) { (hasAny(c, PREMIUM) ? P : hasAny(c, EVERYDAY) ? E : O).push(c); });
    var N = cars.length, nFeat = Math.ceil(N / 5), feats = [];
    function takeFeature(pool, strict) {
      for (var q = 0; q < pool.length; q++) {
        var c = pool[q];
        if (!strict || (photoScore(M.photoOf(c)) >= 2 && !nonRoad(c))) return pool.splice(q, 1)[0];
      }
      return null;
    }
    for (var f = 0; f < nFeat; f++) {
      var pref = f % 2 === 0 ? [P, E, O] : [E, P, O], fc = null;
      for (var k = 0; k < 3 && !fc; k++) fc = takeFeature(pref[k], true);
      for (k = 0; k < 3 && !fc; k++) fc = takeFeature(pref[k], false);
      feats.push(fc);
    }
    var out = [], rr = 0, pools = [O, E, P];
    for (var i = 0; i < N; i++) {
      var c = i % 5 === 0 ? feats[i / 5] : null;
      for (var t = 0; t < 3 && !c; t++) { var pl = pools[rr++ % 3]; if (pl.length) c = pl.shift(); }
      if (!c) c = (P.length ? P : E.length ? E : O).shift();
      if (c) out.push(c);
    }
    return out;
  }

  // "Why this car" comes ONLY from the car's own `why` field (vehicle.why).
  // Empty → no line for customers; in the theme editor, a content-needed note.
  function whyLines(car) {
    return String(car.why || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function decorateCard(el, car, isFeature) {
    var spec = el.querySelector('.vc-spec');
    var lines = whyLines(car).slice(0, isFeature ? 3 : 1);
    var p = null;
    if (lines.length) {
      p = document.createElement('p');
      p.className = 'li-why';
      p.innerHTML = '<span class="li-why__k">Why this car</span>' + lines.map(function (l) { return '<span class="li-why__v">' + esc(l) + '</span>'; }).join('');
    } else if (isDesign()) {
      p = document.createElement('p');
      p.className = 'li-why li-why--needed content-needed content-needed--inline';
      p.innerHTML = '<span class="content-needed__label">Content needed</span>Why this car: one line in the car&rsquo;s &ldquo;why&rdquo; field.';
    }
    var anchor = spec;
    if (p && spec) { spec.insertAdjacentElement('afterend', p); anchor = p; }
    if (isFeature) {
      el.classList.add('li-feat');
      if (!lines.length) el.classList.add('li-feat--nowhy'); // no "why" line: a shorter plinth, no empty column
      var ns = M.needsOf(car);
      if (ns.length && anchor) {
        var fit = document.createElement('div');
        fit.className = 'li-fits';
        fit.innerHTML = '<p class="li-fits__k">Find it under</p><ul class="li-fits__list" role="list">' + ns.map(function (k) { var nd = M.need(k); return '<li><a class="li-fit" href="' + esc(M.stockUrl({ need: k })) + '">' + esc(nd.label) + '</a></li>'; }).join('') + '</ul>';
        anchor.insertAdjacentElement('afterend', fit);
        anchor = fit;
      }
      // No "why" line yet: the plinth shows the car's own facts instead of an empty column (real fields only).
      if (!lines.length && anchor) {
        var a = M.avail(car);
        var rows = [['Body', car.body], ['Colour', car.colour], ['Condition', car.cond], [car.status === 'in' ? 'Where' : 'Status', car.status === 'in' ? car.loc : a.where]]
          .filter(function (r) { return r[1]; });
        if (rows.length) {
          var dl = document.createElement('dl');
          dl.className = 'li-facts';
          dl.innerHTML = rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
          anchor.insertAdjacentElement('afterend', dl);
        }
      }
    }
    return el;
  }

  // The closing concierge panel: copy lives in the section's <template>.
  function conciergePanel(root, empty) {
    var tpl = root.querySelector('template[data-li-cg]');
    var panel = tpl && tpl.content && tpl.content.firstElementChild ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (!panel) { panel = document.createElement('aside'); panel.className = 'li-cg on-dark'; panel.innerHTML = '<div class="li-cg__inner"></div>'; return panel; }
    var h = panel.querySelector('[data-li-cg-title]');
    if (h && empty && h.getAttribute('data-empty')) h.textContent = h.getAttribute('data-empty');
    panel.querySelectorAll('[data-li-cg-text]').forEach(function (t) {
      t.textContent = t.textContent.replace(/\[network\]/g, M.networkSummary().held);
    });
    panel.querySelectorAll('[data-li-wa]').forEach(function (a) {
      M.waApply(a, a.getAttribute('data-li-wa') || 'Hi AHIHQ Motors, I am looking for a car. Can you help me find one?');
      var ic = a.querySelector('[data-li-wa-icon]'); if (ic) ic.innerHTML = M.icon('whatsapp');
    });
    return panel;
  }

  function parsePicks(grid) {
    try { var v = JSON.parse(grid.getAttribute('data-li-picks') || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }

  function renderGrid(root, grid, countEl, cars) {
    var max = Math.max(1, Math.min(50, parseInt(grid.getAttribute('data-li-max'), 10) || 11));
    var sel = select(cars, max, parsePicks(grid));
    var ordered = sel.picked ? sel.cars : editorialOrder(sel.cars);
    var N = ordered.length;
    var frag = document.createDocumentFragment();
    var smallsRun = 0, lastBlock = 0;
    ordered.forEach(function (car, i) {
      var block = Math.floor(i / 5), pos = i % 5, feature = pos === 0, flip = block % 2 === 1;
      lastBlock = block;
      var el = M.card(car, { variant: feature ? 'feature' : 'default', headingLevel: 'h3', sizes: feature ? '(max-width: 600px) 100vw, 860px' : '(max-width: 600px) 100vw, (max-width: 900px) 50vw, 430px' });
      decorateCard(el, car, feature);
      var cell = document.createElement('div');
      cell.className = 'li-cell ' + (feature ? 'li-cell--f' + (flip ? ' li-cell--fr' : '') : 'li-cell--s' + (pos === 1 && flip ? ' li-cell--sl' : ''));
      cell.appendChild(el);
      frag.appendChild(cell);
      smallsRun = feature ? 0 : smallsRun + 1;
    });
    // concierge panel: fill the space left on the last row (12-column grid)
    var rem = N % 5, flipLast = lastBlock % 2 === 1, w;
    if (N === 0 || rem === 0 || rem === 2) w = 12;
    else if (rem === 3) w = 8;
    else w = 4; // rem 1 (beside a lone feature) or rem 4 (after two smalls)
    var cgCell = document.createElement('div');
    cgCell.className = 'li-cell li-cell--cg li-cg--w' + w + (rem === 1 && flipLast ? ' li-cg--left' : '') + (smallsRun % 2 === 1 ? ' li-cg--m1' : ' li-cg--m2');
    cgCell.appendChild(conciergePanel(root, N === 0));
    frag.appendChild(cgCell);
    grid.innerHTML = '';
    grid.appendChild(frag);
    grid.setAttribute('data-count', N);

    if (!countEl) return;
    var total = cars.length;
    if (!total) { countEl.innerHTML = ''; countEl.hidden = true; return; }
    var k = M.counts(cars);
    countEl.hidden = false;
    countEl.innerHTML = '<b>' + M.fmt(total) + '</b> ' + (total === 1 ? 'car' : 'cars') + ' online' +
      '<span class="li-count__split">' + [k.in ? M.fmt(k.in) + ' here now' : '', k.way ? M.fmt(k.way) + ' arriving' : '', N < total ? 'showing ' + M.fmt(N) : ''].filter(Boolean).join(' · ') + '</span>';
  }

  M.view('life-inventory', {
    init: function () { /* links are plain anchors; save / WhatsApp are delegated globally by the core */ },
    render: function (el, ctx) {
      var cars = (ctx && ctx.cars) || M.cars;
      var ul = el.querySelector('[data-li-tiles]'), grid = el.querySelector('[data-li-grid]');
      if (ul) renderTiles(ul, cars);
      if (grid) renderGrid(el, grid, el.querySelector('[data-li-count]'), cars);
    }
  });

  // theme editor: a re-rendered section arrives as fresh Liquid, so paint it again
  document.addEventListener('shopify:section:load', function () {
    if (document.documentElement.getAttribute('data-ready')) M.rerender();
  });
})();
